import { fetchAsset } from './Actions'
import { selectAsset } from './Selector'
import { assetsSlice, initialState } from './Slices'
import { Agency, Asset } from './Type'

export { fetchAsset }
export { selectAsset }
export { initialState, assetsSlice }
export type { Agency, Asset }

export default assetsSlice.reducer
